import { heroData, images } from "../../data/mock";
import { Button } from "../ui/button";
import { ExternalLink, UserPlus } from "lucide-react";

export const CTASection = () => {
  return (
    <section id="registro" className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={images.worship}
          alt="Adoración"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-950/95 via-brand-900/85 to-brand-950/92" />
      </div>

      {/* Decorative */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-brand-light/5 rounded-full blur-3xl animate-float-slow" />
      <div className="absolute bottom-20 right-20 w-48 h-48 bg-brand-500/5 rounded-full blur-3xl animate-float" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Logo */}
        <div className="mb-10">
          <img
            src={images.logoWhite}
            alt="Tu Iglesia App"
            className="w-28 h-auto mx-auto opacity-80 animate-float-slow"
          />
        </div>

        <h2 className="brand-heading text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Pre-Regístrate en{" "}
          <span className="text-brand-light">Tu Iglesia App</span>
        </h2>

        <p className="text-white/55 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
          Sé de los primeros en acceder a todas las herramientas de tu iglesia en un solo lugar.
          Regístrate ahora y forma parte del futuro digital de tu congregación.
        </p>

        {/* Pre-register CTA */}
        <Button
          asChild
          className="bg-brand-light hover:bg-brand-400 text-brand-950 px-10 py-7 text-xl rounded-2xl font-bold transition-all duration-300 hover:scale-105 shadow-2xl shadow-brand-light/25 gap-3"
        >
          <a
            href={heroData.registroUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <UserPlus className="w-6 h-6" />
            Regístrate Ahora
          </a>
        </Button>

        <p className="text-white/30 text-sm mt-6">
          registro.tuiglesia.app
        </p>

        {/* Website Link */}
        <a
          href={`https://${heroData.websiteUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-brand-light/40 hover:text-brand-300 transition-colors text-sm font-medium mt-4"
        >
          <ExternalLink className="w-4 h-4" />
          {heroData.websiteUrl}
        </a>
      </div>
    </section>
  );
};
